export default {
  state: () => ({
    users: {},
    newUser: {}
  })
}



// WEBPACK FOOTER //
// ./src/app/store/users/config.js